export default {
  id: '67c3a05188',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n<div class="page" data-name="about">\n  <div class="navbar">\n    <div class="navbar-bg"></div>\n    <div class="navbar-inner sliding">\n      <div class="left">\n        <a href="#" class="link back">\n          <i class="icon icon-back"></i>\n          <span class="if-not-md">Back</span>\n        </a>\n      </div>\n      <div class="title">About</div>\n    </div>\n  </div>\n  <div class="page-content">\n    <div class="block-title">About AttnSheet</div>\n    <div class="block block-strong">\n      <div class="text-align-center">\n        <img src="/static/icons/128x128.png">\n        <p>\n          version 1.0\n        </p>\n        <p>\n          AttnSheet is a simple attendance management app which is intregrated with your Google Drive. \n        </p>\n        <p>\n          AttnSheet by Soumyadip Mondal (@unsuitable001)\n        </p>\n          <a href="https://github.com/unsuitable001" class="link external">\n            <i class="icon f7-icons">logo_github</i>\n          </a>\n          <a href="https://gitter.im/unsuitable001" class="link external">\n            <i class="icon f7-icons">text_bubble</i>\n          </a>\n      </div>\n    </div>\n  </div>\n</div>\n';
      return r;
    }(this);
  },
  styleScoped: false
};